import React from 'react'
import { Input,AutoComplete } from "antd";
import SelectComp from "../../NewComponent/Select/Select";
import { getCategoryExperts,getRerouteUser, fetchUsers_CM_Atomizer } from '../../API/api';
import Button from '../../NewComponent/Button/Button';
import { useSelector } from 'react-redux';

export default function ExtraFilters({handleCancel, bulkUpdate,isOpen}) {
    const [rerouteUser, setRerouteUser] = React.useState([]);
    const [categoryExperts, setCategoryExperts] = React.useState([]);
    const emailState = useSelector((state) => state.emailTicket);
    // create state for all the filters
    const [filters, setFilters] = React.useState({
        status: 'any',
        domain: "",
        assignedTo: "",
        subject: '',
        emailBody: '',
        from: '',
        threadId: ''
    });
const [fromValOptions, setFromValOptions] = React.useState('');

    const handleSubmit = () => {
        bulkUpdate(filters);
        handleCancel();
    };

    const handleClearFilters = () => {
        bulkUpdate({
        status: 'any',
        domain: null,
        assignedTo: null,
        subject: '',
        emailBody: '',
        from: '',
        threadId: ''
    });
        handleCancel();
    };
    // craete a function to handle the change in filters
    const handleFilterChange = (key, value) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            [key]: value
        }));
    };

    const fetchCategoryExperts = async () => {
        // setLoading(true);
        try {
          const response = await getCategoryExperts();
          if (response && response.data) {
            response.data.data.forEach((user) => {
            user.label = user.domainName;
            user.value = user.label;
          });
            setCategoryExperts(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching category experts:", error);
        } finally {
          // setLoading(false);
        }
      };
  const headigStyles2 = {
    // fontSize: "16px",
    // lineHeight: "22px",
    color: "#5C667B",
    marginBlock:'10px',
    // fontWeight: "300",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const fetchExperts = async () => {
      try {
        const response = await getRerouteUser();
        if (response && response.data) {
          response.data.data['users'].forEach((user) => {
            user.label = user.firstName + ' ' + user.lastName;
            user.value = user.firstName + ' ' + user.lastName+"&"+user.userUuid;
          });
          setRerouteUser(response.data.data['users']);
        }
      } catch (error) {
        console.error("Error fetching category experts:", error);
      } finally {
        // setLoading(false);
      }
    };

    const onChnageFrom = (value) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            from: value
        }));
        setFromValOptions([]);
        if(value.length > 3){
          fetchUsers_CM_Atomizer(value, "seeker")
          .then((res) => {
            // setFromValOptions(res.data.data['users']);
            const options = res.data.data['users'].map((user) => ({
              label: user.firstName + ' ' + user.lastName + ' (' + user.email + ')',
              value: user.email
            }));
            setFromValOptions(options); 
          })
        }
    }
    React.useEffect(() => {
          if(isOpen) {
            fetchExperts();
        fetchCategoryExperts();
        setFilters({
            status: emailState.status ,
            domain: emailState.domain ,
            assignedTo: emailState.assignedTo ,
            subject: emailState.subject ,
            emailBody: emailState.emailBody ,
            from: emailState.from ,
            threadId: emailState.threadId
        });
          }
      }, [isOpen]);
  return (
    <>
      <div style={{}}>
        <div>
          <div style={headigStyles2}>
            <div style={{width:'30%'}}>Status&nbsp;</div>
            <div style={{width:'60%'}}>
              <SelectComp onChangeFunc={(e)=>handleFilterChange('status',e)} isString={false} placeholder='Select Expert' val={filters.status} options={[{label:'Any Status',value:'any'},{label:'Open',value:'Open'},{label:'Closed',value:'Closed'}]}  size='large' width={'100%'} />
            </div>
          </div>
          <div style={headigStyles2}>
            <div style={{width:'30%'}}>Domain&nbsp;</div>
            <div style={{width:'60%'}}>
              <SelectComp onChangeFunc={(e)=>handleFilterChange('domain',e)} isString={false} placeholder='Select domain' val={filters.domain} options={categoryExperts}  size='large' width={'100%'}/>
            </div>
          </div>
          <div style={headigStyles2}>
            <div style={{width:'30%'}}>Assigned to&nbsp;</div>
            <div style={{width:'60%'}}>
              <SelectComp onChangeFunc={(e)=>handleFilterChange('assignedTo',e)}  isString={false} placeholder='Select Expert' val={filters.assignedTo} size='large' options={rerouteUser} width={'100%'}/>
            </div>
          </div>
          <div style={headigStyles2}>
            <div style={{width:'30%'}}>Subject&nbsp;</div>
            <div style={{width:'60%'}}>
              <Input id='inputID2' type='text' onChange={(e)=>handleFilterChange('subject',e.target.value)} value={filters.subject} placeholder='Enter email subject' size='large'/>
            </div>
          </div>
          <div style={headigStyles2}>
            <div style={{width:'30%'}}>Email body&nbsp;</div>
            <div style={{width:'60%'}}>
              <Input id='inputID2' placeholder='Enter email body' onChange={(e)=>handleFilterChange('emailBody',e.target.value)} value={filters.emailBody} size='large'/>
            </div>
          </div>
          <div style={headigStyles2}>
            <div style={{width:'30%'}}>Thread id&nbsp;</div>
            <div style={{width:'60%'}}>
              <Input id='inputID2' size='large' onChange={(e)=>handleFilterChange('threadId',e.target.value)}   value={filters.threadId} placeholder='Enter email thread id'/>
            </div>
          </div>
          <div style={headigStyles2}>
            <div style={{width:'30%'}}>From&nbsp;</div>
            <div style={{width:'60%'}}>
              <AutoComplete id='inputID2'  onBlur={()=>setFromValOptions([])} onSelect={(data) => console.log(data)} size='large' options={fromValOptions} onChange={e=>onChnageFrom(e)} value={filters.from} style={{width:'100%',fontSize:'16px'}} placeholder='Enter seeker name or email address' />
            </div>
          </div>
        </div>
        
      </div>
      <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px'}}>
        <div>
          <Button type={'secondary'} text={'Clear filters'} onClickFunc={handleClearFilters}/>
        </div>
        &nbsp;&nbsp;
        <div>
          <Button type={'secondary'} text={'Cancel'} onClickFunc={handleCancel}/>
        </div>
        &nbsp;&nbsp;
        <div>
          <Button type={'primary'} text={'Apply'} onClickFunc={handleSubmit}/>
        </div>
      </div>
    </>
  );
}
